import { render, staticRenderFns } from "./ConvenioAcoes.vue?vue&type=template&id=b7be975a"
import script from "./ConvenioAcoes.vue?vue&type=script&lang=js"
export * from "./ConvenioAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports